import {Submissions} from '@wix/wix-events-commons-statics'
import {RegFormData} from '../../types/registration'

export const getInitialValuesOld = ({
  ticketed,
  order,
  buyerDetails,
  rsvpDetails,
  defaultFormValues,
}: {
  ticketed: boolean
  order: wix.events.ticketing.Order
  buyerDetails: RegFormData
  rsvpDetails: RegFormData
  defaultFormValues: Partial<RegFormData>
}) => {
  const initialTicketedValues = order ? getInitialTicketedValues(order) : (buyerDetails ?? {})
  const filledValues = ticketed ? initialTicketedValues : (rsvpDetails ?? {})

  return Object.keys(filledValues).length ? filledValues : defaultFormValues
}

const getInitialTicketedValues = (order: wix.events.ticketing.Order): Partial<RegFormData> => {
  const inputValues = order?.checkoutForm?.inputValues
  const initialValues = {}

  if (inputValues) {
    inputValues.forEach(({inputName, value, values}) => {
      initialValues[inputName] = value || values
    })
  }

  return initialValues
}

export const getInitialValues = ({
  ticketed,
  buyerDetails,
  rsvpDetails,
  defaultFormValues,
  order,
}: {
  ticketed: boolean
  buyerDetails: Submissions
  rsvpDetails: Submissions
  defaultFormValues: Submissions
  order: wix.events.ticketing.Order
}) => {
  const initialTicketedValues = order?.checkoutFormSubmission?.submissions ?? buyerDetails ?? {}
  const filledValues = ticketed ? initialTicketedValues : (rsvpDetails ?? {})

  return Object.keys(filledValues).length ? filledValues : defaultFormValues
}
